module.exports = __webpack_public_path__ + "845291092b9e62fbf35308b77808843c.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/image/ic_logout.svg
// module id = 1163
// module chunks = 0